import React from 'react';
import PropTypes from 'prop-types';
import { stripTags } from '../../../utilities/functions';
import { restructureHours } from '../../../utilities/branches';

const LocalShowroom = (props) => {
	if (!props.data) return null;

	const structuredMembersOf =
		props.data.memberOf?.map((card) =>
			JSON.stringify({
				'@type': 'Organization',
				'name': stripTags(card.heading),
				'url': card.ctas?.[0]?.link?.href,
			})
		) || [];

	const structuredFunder =
		props.data.funder?.map((card) =>
			JSON.stringify({
				'@type': 'Organization',
				'name': stripTags(card.heading),
				'url': card.ctas?.[0]?.link?.href,
			})
		) || [];

	const structuredAwards = props.data.awards?.map((card) => JSON.stringify(stripTags(card.heading)));
	const structuredSocials = props.data.socials?.map((social) => JSON.stringify(stripTags(social.link?.href)))?.join(', ');

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "HomeAndConstructionBusiness",
				"name": "${props.data.name}",
				"description": "${props.data.description}",
				"logo": ["https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blt5d51af0d3a33260d/63615b77ff7b405f6b3f58e9/pella-logo-black-spot.png"],
				"image": ["https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blt5d51af0d3a33260d/63615b77ff7b405f6b3f58e9/pella-logo-black-spot.png"],
				"telephone": "${props.data.phone}",
				"address": {
					"@type": "PostalAddress",
					"streetAddress": "${props.data.line_1}",
					"addressLocality": "${props.data.city}",
					"addressRegion": "${props.data.state}",
					"postalCode": "${props.data.postal_code}",
					"addressCountry": "${props.data.country}"
				},
				"hasMap": "${props.mapUrl}",
				"geo": {
					"@type": "GeoCoordinates",
					"latitude": "${props.data.location?.coordinates?.[1]}",
					"longitude": "${props.data.location?.coordinates?.[0]}"
				},
				"openingHoursSpecification": [${restructureHours(props.data).map((hours) => JSON.stringify(hours))}],
				"areaServed": [${props.areaServed.map((area) => `{ "@type": "City", "name": "${area}" }`)}],
				"url": "${process.env.GATSBY_SITE_URL + props.url}",
				"sameAs": [${structuredSocials}],
				"award": [${structuredAwards}],
				"funder": [${structuredFunder}],
				"memberOf": [${structuredMembersOf}]${
					(props.data.offer?.option1 &&
						`,
				"offers": {
					"@type": "Offer",
					"name": "${props.data.offer.option1} ${props.data.offer.conjunction1 || ''} ${props.data.offer.option2 || ''} ${props.data.offer.conjunction2 || ''} ${props.data.offer.option3 || ''}",
					"priceCurrency": "USD",
					"availability": "https://schema.org/InStock",
					"url": "${process.env.GATSBY_SITE_URL}/where-to-buy/schedule-consultation/"
				}`) ||
					''
				}
			}`,
			}}
		/>
	);
};

LocalShowroom.propTypes = {
	data: PropTypes.object,
	areaServed: PropTypes.array,
	url: PropTypes.string,
	mapUrl: PropTypes.string,
};

export default LocalShowroom;
